import { IconProps } from '../constants'
import SVGContainer from './svg-container'

const ChevronUp = (props: IconProps) => (
  <SVGContainer {...props}>
    <path
      d='M5 15L12 8L19 15'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </SVGContainer>
)

export default ChevronUp
